import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { BaseModal } from '../modals/base_modal.component';
import { Input } from '../inputs/input.component';
import { Button } from '../inputs/button.component';
import { PencilIcon } from 'components/icons/pencil.icon';

interface RenameModalProps {
  isOpen: boolean;
  isLoading: boolean;
  initialName: string;
  onClose: () => void;
  onConfirm: ( name: string ) => void;
}
export function RenameModal( { isOpen, isLoading, initialName, onClose, onConfirm }: RenameModalProps ) {
  const { t } = useTranslation();
  const [ name, setName ] = useState( initialName ?? '' );

  useEffect( () => {
    if ( isOpen ) { setName( initialName ?? '' ); }
  }, [ isOpen, initialName ] );

  const handleClose = () => {
    setName( '' );
    onClose();
  };

  const handleConfirm = () => {
    if ( name.trim() === '' ) { return; }
    onConfirm( name.trim() );
    setName( '' );
  };

  return (
    <BaseModal
      title={ t( 'translation:rename' ) }
      isOpen={ isOpen }
      onClose={ handleClose }
      icon={ <PencilIcon className="w-5 h-5 fill-current" /> }
      iconColor="#ef4444"
    >
      <div className="flex flex-col gap-4 p-4">
        <Input
          value={ name }
          label={ t( 'translation:name' ) }
          placeholder={ t( 'translation:new_name' ) }
          required
          disabled={ isLoading }
          onChange={ val => { setName( val ); } }
          onKeyEnterUp={ () => { handleConfirm(); } }
        />
        <div className="flex justify-end gap-2">
          <Button
            label={ t( 'translation:cancel' ) }
            color="#6b7280"
            colorHover="#4b5563"
            disable={ isLoading }
            onClick={ handleClose }
          />
          <Button
            label={ isLoading ? t( 'translation:modification' ) : t( 'translation:rename' ) }
            color="#ef4444"
            colorHover="#dc2626"
            disable={ name.trim() === '' || isLoading }
            onClick={ handleConfirm }
          />
        </div>
      </div>
    </BaseModal>
  );
}
